module.exports = __webpack_public_path__ + "img/ecu_banner_es.24f31420.jpg";